import { cva } from "class-variance-authority";

import { cn } from "@/shared/helpers/cn.helper";

const variants = cva("", {
  variants: {
    variant: {
      default: "[&_tr:last-child]:border-0",
      unstyled: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const TableBody: React.FC<React.ComponentProps<"tbody"> & { variant?: "default" | "unstyled" }> = ({
  className,
  variant,
  ...props
}) => {
  return (
    <tbody
      className={cn(variants({ variant }), className)}
      data-slot="table-body"
      {...props}
    />
  );
};
